export type PhotoCaptureMethod = "native-capture-input" | "in-browser-camera";

export const choosePhotoCaptureMethod = (
    fileInput: HTMLInputElement,
): PhotoCaptureMethod =>
    "capture" in fileInput ? "native-capture-input" : "in-browser-camera";
